export default "__VITE_ASSET__B$zhAh86__"